import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { opsProposalEndpoints } from '@/lib/api/endpoints';
import { proposalKeys } from '@/lib/queryKeys';
import type { Attachment } from '@/types/attachment';

export function useProposalAttachments(proposalId: string) {
  return useApiQuery<Attachment[]>({
    queryKey: proposalKeys.attachments(proposalId),
    queryFn: () =>
      apiGet<Attachment[]>(operationsClient, opsProposalEndpoints.attachments(proposalId)),
    enabled: Boolean(proposalId),
  });
}
